// ONYX-CUSTOM: one-card-at-a-time slider for recently viewed and products list
/**
 * One-card-at-a-time slider for the mobile menu's recently viewed list layout.
 * Not product-slider.js: that one tears the slider down on mobile and keys its breakpoints
 * off window width, neither of which fits a drawer that is a single column at every width.
 */
if (!customElements.get('recently-viewed-list-slider')) {
  customElements.define(
    'recently-viewed-list-slider',
    class RecentlyViewedListSlider extends HTMLElement {
      connectedCallback() {
        if (parseInt(this.dataset.totalItems) < 2) return;

        const container = this.querySelector('.swiper');
        if (!container || typeof this.carousel === 'object') return;

        this.carousel = new FoxTheme.Carousel(container, {
          slidesPerView: 1,
          spaceBetween: 8,
          loop: false,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            type: 'fraction',
          },
        });
        this.carousel.init();
      }

      disconnectedCallback() {
        this.carousel?.slider?.destroy();
      }
    }
  );
}
